function isOnScreen(elem) {
	// if the element doesn't exist, abort
	if( elem.length == 0 ) {
		return;
	}
	var $window = jQuery(window)
	var viewport_top = $window.scrollTop()
	var viewport_height = $window.height()
	var viewport_bottom = viewport_top + viewport_height
	var $elem = jQuery(elem)
	var top = $elem.offset().top
	var height = $elem.height()
	var bottom = top + height

	return (top >= viewport_top && top < viewport_bottom) ||
	(bottom > viewport_top && bottom <= viewport_bottom) ||
	(height > viewport_height && top <= viewport_top && bottom >= viewport_bottom)
}
var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
  return new bootstrap.Tooltip(tooltipTriggerEl)
})


 

$(document).ready(function(){

	if( isOnScreen($(".non-sticky-atc-button").eq(0)) ||
     	isOnScreen($(".non-sticky-atc-button").eq(1)) || 
     	isOnScreen($(".non-sticky-atc-button").eq(2)) ||
		isOnScreen($(".non-sticky-atc-button").eq(3)) || 
		isOnScreen($(".non-sticky-atc-button").eq(4)) || 
		isOnScreen($(".non-sticky-atc-button").eq(5)) || 
		 isOnScreen($("#footer")) )   {
    	$(".sticky-atc-button").fadeOut(100);

  	} else {
    	$(".sticky-atc-button").fadeIn(100);
  	}
  
  	$(window).on('scroll',function(){
    	if( isOnScreen($(".non-sticky-atc-button").eq(0)) ||
	     	isOnScreen($(".non-sticky-atc-button").eq(1)) || 
	     	isOnScreen($(".non-sticky-atc-button").eq(2)) ||
			isOnScreen($(".non-sticky-atc-button").eq(3)) || 
			isOnScreen($(".non-sticky-atc-button").eq(4)) ||
			isOnScreen($(".non-sticky-atc-button").eq(5)) ||  
			isOnScreen($("#footer")) )   {
      		$(".sticky-atc-button").fadeOut(10);
      
    	} else {
     		$(".sticky-atc-button").fadeIn(10);
    	}
  	});	
	jQuery('.scrollTo').click(function(e) {
        var jump = jQuery(this).attr('href');
        var new_position = jQuery(jump).offset();
        var scroll = 0;
        jQuery('html, body').stop().animate({ scrollTop: new_position.top + scroll }, 2000, function(){
            var new_position = jQuery(jump).offset();
            jQuery('html, body').stop().animate({ scrollTop: new_position.top + scroll }, 2000);
        });
        e.preventDefault();
    });	
	
	$(".mobile-menu-icon").click(function (e) {
		$("body").addClass("open_sidebar");
		e.stopPropagation();
	  });
	$(".close_menu").click(function (e) {
		$("body").removeClass("open_sidebar");
	});
	// if ($('.product-list').length > 0) {
	// 	$(".product-list").mCustomScrollbar({
	// 		theme:"minimal-dark",
	// 		scrollbarPosition: "inside",
	// 	});
	// }

	if($('.menu-list ').length > 0){
		$('.menu-list > li .icon-down-open').click(function(){
			$(this).closest("li").toggleClass(' active ');
			$(this).closest("li").siblings().removeClass(' active '); 
			$(".submneu").stop().slideUp();
			$('.active > .submneu').stop().slideDown();
			return false;
		});
	}
	
	if($('.faq-accordion').length > 0){
		$('.faq-accordion .item').click(function(){
			$(this).toggleClass(' active ');
			$(this).siblings().removeClass(' active '); 
			$('.faq-answer').stop().slideUp();
			$('.active .faq-answer').stop().slideDown();
			return false;
		});
	}
	if($('.category-list').length > 0){
		$('.category-list .item').click(function(){
			$(this).toggleClass(' active ');
			$(this).siblings().removeClass(' active '); 
			$('.sub-item').stop().slideUp();
			$('.active .sub-item').stop().slideDown();
			return false;
		});
	}
	
	if ($('.product-slider').length > 0) {		
		$('.product-slider').slick({
			slidesToShow: 4,
			slidesToScroll: 1,
			lazyLoad: 'progressive',
			arrows: true,
			dots: false,	
			infinite: false,
			prevArrow: '<button type="button" class="prev-arrow"><span class="icon-left-open"></span></button>',
			nextArrow: '<button type="button" class="next-arrow"><span class="icon-right-open"></span></button>',			
			responsive: [				
				{
				  breakpoint: 991,
				  settings: {
					slidesToShow: 3,
				  }
				},
				{
					breakpoint: 767,
					settings: {
					  slidesToShow: 2,
					}
				},
				{
					breakpoint: 575,
					settings: {
					  slidesToShow: 1,
					}
				  }
			]		
		});			  
	}
	if ($('.cart-product-slider').length > 0) {		
		$('.cart-product-slider').slick({
			slidesToShow: 4,
			slidesToScroll: 1,
			lazyLoad: 'progressive',
			arrows: true,
			dots: false,	
			infinite: false,
			prevArrow: '<button type="button" class="prev-arrow"><span class="icon-left-open"></span></button>',
			nextArrow: '<button type="button" class="next-arrow"><span class="icon-right-open"></span></button>',			
			responsive: [	
				{
					breakpoint: 991,
					settings: {
					  slidesToShow: 3,
					}
				},
				{
					breakpoint: 767,
					settings: {
					  slidesToShow: 2,
					}
				},
				{
					breakpoint: 575,
					settings: {
					  slidesToShow: 1,
					}
				  }
			]		
		});			  
	}
	if ($('.testimonial-slider').length > 0) {		
		$('.testimonial-slider').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			lazyLoad: 'progressive',
			arrows: true,
			dots: false,	
			infinite: true,
			prevArrow: '<button type="button" class="prev-arrow"><span class="icon-left-open"></span></button>',
			nextArrow: '<button type="button" class="next-arrow"><span class="icon-right-open"></span></button>',		
				
		});			  
	}
	if($('.review-slider').length > 0) {		
		$('.review-slider').slick({
			slidesToShow: 4,
			slidesToScroll: 1,
			lazyLoad: 'progressive',
			arrows: true,
			dots: false,	
			infinite: true,
			prevArrow: '<button type="button" class="prev-arrow"><span class="icon-left-open"></span></button>',
			nextArrow: '<button type="button" class="next-arrow"><span class="icon-right-open"></span></button>',	
			responsive: [				
				{
				  breakpoint: 991,
				  settings: {
					slidesToShow: 3,
				  }
				},
				{
					breakpoint: 767,
					settings: {
					  slidesToShow: 2,
					}
				},
				{
					breakpoint: 575,
					settings: {
					  slidesToShow: 1,
					}
				  }
			]		
				
		});	
	}
	$('.pdp-tabs ul li a').click(function(){
		$('li a').removeClass("active");
		$(this).addClass("active");
	});
	$('#tabs-faq-section a').on('click', function (e) {
		e.preventDefault()
		$(this).tab('show')
	  })
	$('.modal-toggle-1').on('click', function(e) {
		e.preventDefault();
		$('.modal-1').toggleClass('is-visible');		
	});
	$('.modal-toggle-2').on('click', function(e) {
		e.preventDefault();
		$('.modal-2').toggleClass('is-visible');		
	});
	if ($('.slider-for').length > 0) {
		$('.slider-for').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			lazyLoad: 'progressive',
			infinite: true,
			draggable:false,
			asNavFor: '.slider-nav',
			prevArrow: '<button type="button" class="prev-arrow"><span class="icon-left-open"></span></button>',
			nextArrow: '<button type="button" class="next-arrow"><span class="icon-right-open"></span></button>',		
		});	
	}
	if ($('.slider-nav').length > 0) {	
		var test = $(".slider-nav .item").length;	
	}
	if (test <= 7) {
		$(".slider-nav").addClass("show-six-item");
	}
	else{
		$(".slider-nav").removeClass("show-six-item");
	}
	if ($('.slider-nav').length > 0) {			
		$('.slider-nav').slick({
			slidesToShow: 6,
			slidesToScroll: 1,
			lazyLoad: 'progressive',
			asNavFor: '.slider-for',
			arrows: false,
			dots: false,
			infinite: true,			
			focusOnSelect: true,	
		});			  
	}
	if($('.after-before-slider').length > 0){
		$('.after-before-slider').slick({
			slidesToShow: 1,
			slidesToScroll: 1,			
			arrows: true,
			dots: false,
			infinite: true,	
			lazyLoad: 'progressive',	
			prevArrow: '<button type="button" class="prev-arrow"><span class="icon-left-open"></span></button>',
			nextArrow: '<button type="button" class="next-arrow"><span class="icon-right-open"></span></button>',	
		});
	}
	
	if ($('.quantity').length > 0) {	
		$('.quantity').on('click', '.plus', function(e) {
			let $input = $(this).prev('input.qty');
			let val = parseInt($input.val());
			$input.val( val+1 ).change();
		});

		$('.quantity').on('click', '.minus', 
			function(e) {
			let $input = $(this).next('input.qty');
			var val = parseInt($input.val());
			if (val > 0) {
				$input.val( val-1 ).change();
			} 
		});
	}
	var initialText = $('.editable').val();
		$('.editOption').val(initialText);

		$('#test').change(function(){
		var selected = $('option:selected', this).attr('class');
		var optionText = $('.editable').text();

		if(selected == "editable"){
			
			$('.editOption').show();				
			//$('.editOption').addClass('js_edit_qty');
			$('.editOption').focus();		
			$('.editOption').keyup(function(){
				var editText = $('.editOption').val();				
				$('.editable').val(editText);
				$('.editable').html(editText);
			});
		}else{
		$('.editOption').hide();
		}
	});
	
	var showChar = 150;  // How many characters are shown by default
	var ellipsestext = "";
	var moretext = "Lees verder";
	var lesstext = "Read Less";
	

	$('.collection-banner .short-description p').each(function() {
		var content = $(this).html();	 
		if(content.length > showChar) {	 
			var c = content.substr(0, showChar);
			var h = content.substr(showChar, content.length - showChar);	 
			var html = c + '<span class="moreellipses">' + ellipsestext+ '&nbsp;</span><span class="morecontent"><span>' + h + '</span>&nbsp;&nbsp;<a href="javascript:;" class="morelink">' + moretext + '</a></span>';
			$(this).html(html);
		}	 
	});	 
	$(".morelink").click(function(){
		if($(this).hasClass("less")) {
			$(this).removeClass("less");
			$(this).html(moretext);
		} else {
			$(this).addClass("less");
			$(this).html(lesstext);
		}
		$(this).parent().prev().toggle();
		$(this).prev().toggle();
		return false;
	});
	// if ($('.boost-pfs-filter-right-col').length > 0) {	
	// 	$(".boost-pfs-filter-right-col .btn-add-to-cart button").click(function(){
	// 		$("body").scrollTop(0);
	// 	});
	// }

    // Latest Arrival Tab start here
    
    //alert('here');
	
    $('.js-latest-arrivals-tabs a').click(function(){
  
     $('.js-latest-arrivals-panel').hide();
     $('.js-latest-arrivals-tabs a.active').removeClass('active');
     $(this).addClass('active');
     
     var panel = $(this).attr('href');
     $(panel).fadeIn(1000);
     destroyLatestArrivalSlider(); 
     initializeLatestArrivalSlider();
     setPositionLatestArrivalSlider();
     matchProductHeight();
     // console.log(panel);
     return false;  // prevents link action
    
    });  // end click 

    
    // Latest Arrival Tab end here


  // Explore product Tab start here
    
    //alert('here');
	
    $('.js-latest-arrivals-tabs2 a').click(function(){
  
     $('.js-latest-arrivals-panel2').hide();
     $('.js-latest-arrivals-tabs2 a.active').removeClass('active');
     $(this).addClass('active');
     
     var panel = $(this).attr('href');
     $(panel).fadeIn(1000);
     destroyLatestArrivalSlider2(); 
     initializeLatestArrivalSlider2();
     setPositionLatestArrivalSlider2();
     matchProductHeight();
     // console.log(panel);
     return false;  // prevents link action
    
    });  // end click 

    $('.js-latest-arrivals-tabs2 li:nth-child(2) a').click();
    
    // Explore product Tab end here
     
});

$(window).on("load resize", function (e) {
	matchProductHeight();
});

function matchProductHeight() {
  if($('.product-box-details h4 ').length > 0 ){
		$('.product-box-details h4').matchHeight({
			byRow: true,
		});
	}
	if($('.product-box-details > ul ').length > 0 ){
		$('.product-box-details > ul').matchHeight({
			byRow: true,
		});
	}
	if($('.product-box-details > .short-description ').length > 0 ){
		$('.product-box-details > .short-description').matchHeight({
			byRow: true,
		});
	}
}



function fixDiv() {
    var $div = $("#stickynav");
    if ($(window).scrollTop() > $div.data("top")) { 
        $('#stickynav').css({'position': 'fixed'}); 
    }
    else {
        $('#stickynav').css({'position': 'relative'});
    }
}

$("#stickynav").data("top", $("#stickynav").offset().top - 500); // set original position on load
$(window).scroll(fixDiv);

function checkPosition(){
    if (window.matchMedia('(max-width: 767px)').matches) {
		if($('.blog-category').length > 0){
			$(".blog-category h4").click(function(){
				$(".blog-category").toggleClass("showlist");
			});
		}
		if($('.announcement-slider').length > 0){
			$('.announcement-slider').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
				dots: false,	
				infinite: true,
				autoplay: true,
  				autoplaySpeed: 2000,				
			});
		}
    } 
}
$(window).on("load resize",function(e){
    checkPosition();
})

function initializeLatestArrivalSlider() {
		$('.js-latest-arrivals-panel .product-slider').slick({
			slidesToShow: 4,
			slidesToScroll: 1,
			lazyLoad: 'progressive',
			arrows: true,
			dots: false,	
			infinite: false,
			prevArrow: '<button type="button" class="prev-arrow"><span class="icon-left-open"></span></button>',
			nextArrow: '<button type="button" class="next-arrow"><span class="icon-right-open"></span></button>',			
			responsive: [				
				{
				  breakpoint: 991,
				  settings: {
					slidesToShow: 3,
				  }
				},
				{
					breakpoint: 767,
					settings: {
					  slidesToShow: 2,
					}
				},
				{
					breakpoint: 575,
					settings: {
					  slidesToShow: 1,
					}
				  }
			]		
		});			  
}
function destroyLatestArrivalSlider() {
    if ($('.js-latest-arrivals-panel .product-slider').hasClass('slick-initialized')) {
        $('.js-latest-arrivals-panel .product-slider').slick('unslick');
    }
}
function setPositionLatestArrivalSlider() {
     $('.js-latest-arrivals-panel2 .product-slider').slick('setPosition');
}

function initializeLatestArrivalSlider2() {
  if ($('.js-latest-arrivals-panel2 .product-slider').length > 0) {		
		$('.js-latest-arrivals-panel2 .product-slider').slick({
			slidesToShow: 4,
			slidesToScroll: 1,
			lazyLoad: 'progressive',
			arrows: true,
			dots: false,	
			infinite: false,
			prevArrow: '<button type="button" class="prev-arrow"><span class="icon-left-open"></span></button>',
			nextArrow: '<button type="button" class="next-arrow"><span class="icon-right-open"></span></button>',			
			responsive: [				
				{
				  breakpoint: 991,
				  settings: {
					slidesToShow: 3,
				  }
				},
				{
					breakpoint: 767,
					settings: {
					  slidesToShow: 2,
					}
				},
				{
					breakpoint: 575,
					settings: {
					  slidesToShow: 1,
					}
				  }
			]		
		});			  
	}
}
function destroyLatestArrivalSlider2() {
    if ($('.js-latest-arrivals-panel2 .product-slider').hasClass('slick-initialized')) {
        $('.js-latest-arrivals-panel2 .product-slider').slick('unslick');
    }
}
function setPositionLatestArrivalSlider2() {
     $('.js-latest-arrivals-panel2 .product-slider').slick('setPosition');
}
 
 
